module.exports = __webpack_public_path__ + "static/media/pl.eb85242c.svg";